import { Grid, TextField, Typography } from "@mui/material";

type Props = {
  label: string;
  value: string;
  onChange?: React.Dispatch<React.SetStateAction<string>>;
};

const TextInput = ({ label, value, onChange }: Props) => {
  return (
    <Grid container direction="column" marginY={0.5}>
      <Grid item>
        <Typography
          variant="body1"
          color="#333333"
          fontWeight={600}
          fontSize={14}
          paddingY={0.5}
        >
          {label}
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="medium"
          inputProps={{
            style: {
              backgroundColor: "#EDEDED",
            },
          }}
          value={value}
          onChange={(e) => {
            e.preventDefault();
            if (onChange !== undefined) {
              onChange(e.target.value);
            }
          }}
        />
      </Grid>
    </Grid>
  );
};

export default TextInput;
